import { Typography } from '@mui/material'

import { Copy, CopyContainer } from '../../../components/common/copy'

const OfflineCapture = () => {
  const handleReload = () => {
    if (navigator.onLine) {
      window.location.reload()
    } else {
      alert('you are still offline')
    }
  }

  return (
    <div style={{ height: '100vh', width: '100vw' }} onClick={handleReload}>
      <CopyContainer padding="xlarge" noRightMargin={true}>
        <CopyContainer padding={{ bottom: 'xsmall' }}>
          <Copy>
            <Typography variant="h1">Lost</Typography>
          </Copy>
        </CopyContainer>
        <CopyContainer padding={{ left: 'small' }}>
          <Copy>
            <Typography variant="h2">Where am i?</Typography>
            <Typography>You are Offline</Typography>
          </Copy>
        </CopyContainer>
      </CopyContainer>
    </div>
  )
}
export default OfflineCapture
